import React from 'react';
import { Link } from 'react-router-dom';

const LocationList = (props) => (
  <div className="w-full">
    <div className="mx-auto max-w-5xl px-0 md:px-40">
      <ul className="space-y-3">
        {props.locations.map((location) => (
          <li key={location.id} className="list-none">
            <Link
              to={`/${props.evento.id}/location/${location.id}`}
              className="block py-3 px-4 md:px-6 hover:bg-slate-900/70 transition"
            >
              <div className="flex items-center justify-between gap-3">
                {/* Código/Nombre de la localización */}
                <div className="flex-1 min-w-0">
                  <div className="truncate text-white font-medium font-montserrat">
                    {location.codigo}
                  </div>
                  {location.descripcion && (
                    <div className="mt-1 text-sm text-slate-400 font-montserrat">
                      {location.descripcion}
                    </div>
                  )}
                </div>

                {/* Indicador visual de link */}
                <div className="flex-shrink-0 text-slate-500">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export default LocationList;